import { User } from 'types/User';
import { Userpilot } from 'userpilot';

declare global {
  interface Window {
    isUserpilotInitialized: boolean;
  }
}

export function init() {
  window.isUserpilotInitialized = false;

  setup(process.env.REACT_APP_USERPILOT_TOKEN);
}

function setup(token: string | undefined) {
  if (token) {
    window.isUserpilotInitialized = true;
    Userpilot.initialize(token);
  }
}

export function identify(user: User) {
  if (window.isUserpilotInitialized) {
    Userpilot.identify(user.id.toString(), {
      name: `${user.firstname} ${user.lastname}`,
      email: user.email,
      created_at: user.createdAt,
      access_type: user.accessType,
    });
  }
}

export function reload() {
  if (window.isUserpilotInitialized) {
    Userpilot.reload();
  }
}
